import React from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import {WithModal} from '../';
import {HydroTeplo, TeploAll,} from '../entries';
import * as trends from '../../trends.js';
import styles from './style.css';

const cellData = [
    {
        ps: ['ti_8_96_3'],
        chartPs: trends.teplo_t3,
        div_id: styles.Cell1,
        caption: "T °C",
        hint: "Т3 - температура наружного воздуха"
    },
    {
        ps: ['ti_8_96_5'],
        chartPs: trends.teplo_t5,
        div_id: styles.Cell2,
        caption: "T °C",
        hint: "Т5 - температура в узле ВЕНА"
    },
    {
        ps: ['ti_8_96_7'],
        chartPs: trends.teplo_t7,
        div_id: styles.Cell3,
        caption: "T °C",
        hint: "Т7 - температура на выходе котла EK1"
    },
    {
        ps: ['ti_8_96_8'],
        chartPs: trends.teplo_t8,
        div_id: styles.Cell4,
        caption: "T °C",
        hint: "Т8 - температура на выходе котла EK2"
    },
    {ps: ['ti_8_96_16'], div_id: styles.Cell5, caption: "∆T °C", hint: "Т7-Т6 - дельта температур котла ЕК1"},
    {ps: ['ti_8_96_17'], div_id: styles.Cell6, caption: "∆T °C", hint: "Т8-Т6 - дельта температур котла ЕК2"},
    {
        ps: ['ti_8_96_6'],
        chartPs: trends.teplo_t11,
        div_id: styles.Cell7,
        caption: "T °C",
        hint: "Т6 - температура на входе котлов ЕК1, ЕК2"
    },
    {ps: ['ti_8_96_13'], div_id: styles.Cell8, caption: "∆T °C", hint: "Т11-Т6 - дельта температур ТО на генерации"},
    {
        ps: ['ti_8_96_11'],
        chartPs: trends.teplo_t11,
        div_id: styles.Cell9,
        caption: "T °C",
        hint: "Т11 - температура на выходе ТО генерации"
    },
    {
        ps: ['ti_8_96_10'],
        chartPs: trends.teplo_t10,
        div_id: styles.Cell10,
        caption: "T °C",
        hint: "Т10 - температура н авыходе ТО нагрузки"
    },
    {ps: ['ti_8_96_15'], div_id: styles.Cell11, caption: "∆T °C", hint: "Т10-Т9 - дельта температур ТО на нагрузку"},
    {
        ps: ['ti_8_96_9'],
        chartPs: trends.teplo_t10,
        div_id: styles.Cell12,
        caption: "T °C",
        hint: "Т9 - температура обратки с нагрузки"
    },
    {
        ps: ['ti_8_94_8'],
        chartPs: trends.teplo_t12,
        div_id: styles.Cell13,
        caption: "T °C",
        hint: "ТЕ1б- температура в обратном трубопроводе"
    },
    {ps: ['ti_8_94_9'], div_id: styles.Cell14, caption: "∆T °C", hint: "ТЕ1а-1б - Дельта температур подачи и обратки"},
    {
        ps: ['ti_8_94_7'],
        chartPs: trends.teplo_t12,
        div_id: styles.Cell15,
        caption: "T °C",
        hint: "ТЕ1а - температура в подающем трубопроводе"
    },
    {
        ps: ['ti_8_96_2'],
        chartPs: trends.teplo_t2,
        div_id: styles.Cell16,
        caption: "T °C",
        hint: "Т2 - температура подачи в нагрузку"
    },
    {
        ps: ['ti_8_96_23'],
        chartPs: trends.teplo_t2,
        div_id: styles.Cell17,
        caption: "T °C",
        hint: "Тзд3 - задание температуры на отопление",
        className: styles.red
    },
    {
        ps: ['ti_8_96_4'],
        chartPs: trends.teplo_t4,
        div_id: styles.Cell18,
        caption: "T °C",
        hint: "Т4 - температура в контрольном помещении"
    },
    {
        ps: ['ti_8_96_22'],
        chartPs: trends.teplo_t4,
        div_id: styles.Cell19,
        caption: "T °C",
        hint: "Тзд2 - уставка температуры в контрольном помещении",
        className: styles.red
    },
    {
        ps: ['ti_8_96_21'],
        chartPs: trends.teplo_t1,
        div_id: styles.Cell20,
        caption: "T °C",
        hint: "Тзд1 - задание температуры ограничения разряда",
        className: styles.red
    },
    {
        ps: ['ti_8_96_1'],
        chartPs: trends.teplo_t1,
        div_id: styles.Cell21,
        caption: "T °C",
        hint: "Т1 - темепература в баке аккумуляторе"
    }
];

export class Teplo extends WithModal {
    render() {
        const chart = super.render();
        return (
            <div className={[this.props.className, styles.App, "row col-md-12"].join(' ')}>
                <div className={styles.canvases}>
                    <TeploAll canvas_id={styles.canvas0}/>
                    <HydroTeplo params={this.props.params} cellData={cellData} styles={styles} parentScreen={this}/>

                    <div className={classNames('triangleDown', styles.triangle1)}/>
                    <div className={classNames('triangleDown', styles.triangle2)}/>
                    <div className={classNames('triangleUp', styles.triangle3)}/>
                    <div className={classNames('triangleDown', styles.triangle4)}/>
                    <div className={classNames('triangleUp', styles.triangle5)}/>
                    <div className={classNames('triangleDown', styles.triangle6)}/>
                    <div className={classNames('triangleDown', styles.triangle7)}/>
                    <div className={classNames('triangleUp', styles.triangle8)}/>
                    <div className={classNames('triangleUp', styles.triangle9)}/>
                    <div className={classNames('triangleDown', styles.triangle10)}/>
                    <div className={classNames('triangleUp', styles.triangle11)}/>
                    <div className={classNames('triangleUp', styles.triangle12)}/>
                    <div className={classNames('triangleDown', styles.triangle13)}/>
                    <div className={classNames('triangleDown', styles.triangle14)}/>
                    <div className={classNames('triangleDown', styles.triangle15)}/>
                    <div className={classNames('triangleUp', styles.triangle16)}/>
                    <div className={classNames('triangleDown', styles.triangle17)}/>
                    <div className={classNames('triangleUp', styles.triangle18)}/>
                    <div className={classNames('triangleUp', styles.triangle19)}/>

                    {chart}
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <p>
                            ЕК1 - Индукционный нагреватель ТЕРЕН-50(50кВт)<br/>
                            ЕК2 - Индукционный нагреватель ТЕРЕН-100(100кВт)<br/>
                            БА - аккумулятор ТА-25 (полезная емкость 22,5м3)<br/>
                            ТО - теплообменник пластинчатый, проточный<br/>
                            В1, В2 - вентиляторы вытяжные
                        </p>
                    </div>
                    <div className="col-md-4">
                        <p>
                            ЕМ1, ЕМ2 - клапаны байпасов котлов ЕК1 и ЕК2<br/>
                            ЕМ3 - клапан подпитки системы отопления<br/>
                            ЕМ4 - клапан подпитки бака аккумулятора<br/>
                            КТ - клапан трехходовой, регулирующий
                        </p>
                    </div>
                    <div className="col-md-4">

                        <p>
                            Н1, Н2 - циркуляционные насосы контура генерации<br/>
                            Н3, Н4 - циркуляционные насосы контура нагрузки<br/>
                            Форт-04.1 - счетчик учета потребленной теплоэнергии<br/>
                            Эконом-04-5 - автоматический электронный регулятор
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.params
    };
};

export default connect(mapStateToProps)(Teplo);


// WEBPACK FOOTER //
// ./src/components/Teplo/index.jsx